import * as React from 'react';
import * as styles from './Main.css';

export interface IMainProps {
  children: React.ReactNode;
}

export function Main({ children }: IMainProps) {
  return <div className={styles['container']}>{children}</div>;
}
